import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { Job, JobStatus, UploaderShape, initialState, jobIsSettled, makeKey } from './model';

const updateJob = (jobs: Job[], jobID: string, patch: Partial<Job>): Job[] =>
  jobs.map((job) => (job.uuid === jobID ? { ...job, ...patch } : job));

export const uploaderReducer = createReducer<UploaderShape>(initialState, (builder) => {
  builder
    .addCase(actions.cancelAllJobs, (state) => {
      state.jobs = [];
      state.pendingUpload = false;
      state.completedInBackground = false;
    })
    .addCase(actions.jobsInserted, (state, action) => {
      const { jobs } = action.payload;
      const existingKeys = new Set(state.jobs.map(makeKey));
      const newJobs = jobs.filter((j) => !existingKeys.has(makeKey(j)));
      state.jobs = [...state.jobs, ...newJobs];
      state.pendingUpload = false;
      state.completedInBackground = false;
    })
    .addCase(actions.jobUpdated, (state, action) => {
      state.jobs = updateJob(state.jobs, action.payload.jobID, action.payload.jobProps);
      // Flag a background completion so the button can switch to "Complete" and a
      // toast can fire — only when the user isn't already watching the modal.
      if (!state.modalOpen && state.jobs.length > 0 && state.jobs.every(jobIsSettled)) {
        state.completedInBackground = true;
      }
    })
    .addCase(actions.jobRestarted, (state, action) => {
      state.jobs = updateJob(state.jobs, action.payload.jobID, {
        status: JobStatus.PENDING_VALIDATION,
        uploadProgress: null,
        uploadSpeed: null,
        remainingTime: null,
        ellapsedTime: null,
        errorMessage: null,
      });
    })
    .addCase(actions.modalOpened, (state, action) => {
      state.modalOpen = true;
      state.pendingUpload = action.payload?.pendingUpload ?? false;
      state.completedInBackground = false;
    })
    .addCase(actions.modalClosed, (state) => {
      state.modalOpen = false;
      state.pendingUpload = false;
    })
    .addCase(actions.pendingUploadCleared, (state) => {
      state.pendingUpload = false;
    });
});
